var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-wrapper',[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"py-3"},[_vm._v(" Welcome to Daybreak! ")]),_c('p',[_vm._v("To access Daybreak, please contact your system administrator.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }